/**
 * Login Action Creators
 *
 * Redux action creators for the authentication flow.
 * These actions are dispatched by components and handled by the login saga and reducer.
 */
import LoginTypes from './login.types';

/** Initiates the login process with user credentials (phone + password) */
export const loginStart = (data: any) => ({
	type: LoginTypes.LOGIN_START,
	payload: data,
});

/** Dispatched by saga on successful API authentication */
export const loginSuccess = (data: any) => ({
	type: LoginTypes.LOGIN_SUCCESS,
	payload: data,
});

/** Dispatched by saga when authentication fails */
export const loginFailure = (error: unknown) => ({
	type: LoginTypes.LOGIN_FAILURE,
	payload: error,
});

/** Clears the login response after it has been consumed by the UI */
export const loginResponseChanged = () => ({
	type: LoginTypes.LOGIN_RESPONSE_CHANGED,
});

/** Resets login state (used for logout functionality) */
export const loginResponseRestStart = () => ({
	type: LoginTypes.LOGIN_RESPONSE_REST_START,
});

/** Persists decoded login data to the store (used on session restore) */
export const addPersistDataStart = (loginData: any) => ({
	type: LoginTypes.PERSIST_LOGIN_DATA_START,
	payload: loginData,
});

/**
 * SECURITY FIX: Proper logout action that clears Redux state AND
 * removes persisted data from localStorage to prevent stale tokens.
 * Use this instead of loginResponseRestStart for actual logout.
 */
export const logout = () => ({
	type: LoginTypes.LOGOUT,
});
